export const CAS_SCRIPT = import.meta.env.VITE_CAS_SCRIPT;
export const CAS_PAYWALL_ID = import.meta.env.VITE_CAS_PAYWALL_ID;
export const CAS_EXIT_INTERVENTION_ID = import.meta.env
  .VITE_CAS_EXIT_INTERVENTION_ID;
export const CAS_API_KEY = import.meta.env.VITE_CAS_API_KEY;
export const CAS_DOMAIN = import.meta.env.VITE_CAS_DOMAIN;
